/**
 * RCP-458 — one product the backend could not fulfil in the requested quantity (`409` from
 * `cart/add`, `cart/update` and `orders`). `name` is empty when the product no longer exists.
 *
 * `availableQuantity` is part of the contract but must never reach the UI (DoD13).
 */
export interface OutOfStockItem {
  productId: number;
  name: string;
  requestedQuantity: number;
  availableQuantity: number;
}

/** RCP-458 — the `409` ProblemDetails body; the backend puts `items` next to the standard fields. */
export interface OutOfStockProblem {
  title: string;
  status: number;
  items: OutOfStockItem[];
}
